export default __webpack_public_path__ + "static/media/basics.af417e96.md";